<template>
<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.05469 4.36914H20.0547C21.1547 4.36914 22.0547 5.26914 22.0547 6.36914V18.3691C22.0547 19.4691 21.1547 20.3691 20.0547 20.3691H4.05469C2.95469 20.3691 2.05469 19.4691 2.05469 18.3691V6.36914C2.05469 5.26914 2.95469 4.36914 4.05469 4.36914Z" stroke="#773DBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M22.0547 6.36914L12.0547 13.3691L2.05469 6.36914" stroke="#773DBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
